<!--
<template>
  <div>
    <h1>Teste de velocidade</h1>
    <div id="startStopBtn" @click="startStop" :class="{ running: isRunning }">
      {{ buttonText }}
    </div>
    <div id="test">
      <div class="testGroup">
        <div class="testArea">
          <div class="testName">Download</div>
          <canvas ref="dlMeter" class="meter"></canvas>
          <div class="meterText">{{ dlText }}</div>
          <div class="unit">Mbps</div>
        </div>
        <div class="testArea">
          <div class="testName">Upload</div>
          <canvas ref="ulMeter" class="meter"></canvas>
          <div class="meterText">{{ ulText }}</div>
          <div class="unit">Mbps</div>
        </div>
      </div>
      <div class="testGroup">
        <div class="testArea">
          <div class="testName">Ping</div>
          <canvas ref="pingMeter" class="meter"></canvas>
          <div class="meterText">{{ pingText }}</div>
          <div class="unit">ms</div>
        </div>
      </div>
      <div id="ipArea">
        IP: <span id="ip">{{ ipAddress }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRunning: false,
      buttonText: "Iniciar",
      dlText: "",
      ulText: "",
      pingText: "",
      ipAddress: "",
      meterBk: "#E0E0E0",
      dlColor: "#6060AA",
      ulColor: "#309030",
      pingColor: "#AA6060",
      jitColor: "#AA6060",
      progColor: "#EEEEEE",
      w: null,
      data: null,
    };
  },
  methods: {
    startStop() {
      if (this.w !== null) {
        this.w.postMessage("abort");
        this.w = null;
        this.data = null;
        this.isRunning = false;
        this.buttonText = "Iniciar";
        this.initUI();
      } else {
        this.w = new Worker("speedtest_worker.min.js");
        this.w.postMessage("start");
        this.isRunning = true;
        this.buttonText = "Parar";
        this.w.onmessage = (e) => {
          this.data = e.data.split(";");
          const status = Number(this.data[0]);
          if (status >= 4) {
            this.isRunning = false;
            this.buttonText = "Iniciar";
            this.w = null;
            this.updateUI(true);
          }
        };
      }
    },
    updateUI(forced) {
      if (!forced && (!this.data || !this.w)) return;
      const status = Number(this.data[0]);
      this.ipAddress = this.data[4];
      this.dlText = status == 1 && this.data[1] == 0 ? "..." : this.data[1];
      this.drawMeter(
        this.$refs.dlMeter,
        this.mbpsToAmount(
          Number(this.data[1] * (status == 1 ? this.oscillate() : 1))
        ),
        this.meterBk,
        this.dlColor,
        Number(this.data[6]),
        this.progColor
      );
      this.ulText = status == 3 && this.data[2] == 0 ? "..." : this.data[2];
      this.drawMeter(
        this.$refs.ulMeter,
        this.mbpsToAmount(
          Number(this.data[2] * (status == 3 ? this.oscillate() : 1))
        ),
        this.meterBk,
        this.ulColor,
        Number(this.data[7]),
        this.progColor
      );
      this.pingText = this.data[3];
      this.drawMeter(
        this.$refs.pingMeter,
        this.msToAmount(
          Number(this.data[3] * (status == 2 ? this.oscillate() : 1))
        ),
        this.meterBk,
        this.pingColor,
        Number(this.data[8]),
        this.progColor
      );
    },
    oscillate() {
      return 1 + 0.02 * Math.sin(Date.now() / 100);
    },
    mbpsToAmount(s) {
      return 1 - 1 / Math.pow(1.3, Math.sqrt(s));
    },
    msToAmount(s) {
      return 1 - 1 / Math.pow(1.08, Math.sqrt(s));
    },
    drawMeter(c, amount, bk, fg, progress, prog) {
      const ctx = c.getContext("2d");
      const dp = window.devicePixelRatio || 1;
      const cw = c.clientWidth * dp;
      const ch = c.clientHeight * dp;
      const sizScale = ch * 0.0055;
      if (c.width == cw && c.height == ch) {
        ctx.clearRect(0, 0, cw, ch);
      } else {
        c.width = cw;
        c.height = ch;
      }
      ctx.beginPath();
      ctx.strokeStyle = bk;
      ctx.lineWidth = 16 * sizScale;
      ctx.arc(
        c.width / 2,
        c.height - 58 * sizScale,
        c.height / 1.8 - ctx.lineWidth,
        -Math.PI * 1.1,
        Math.PI * 0.1
      );
      ctx.stroke();
      ctx.beginPath();
      ctx.strokeStyle = fg;
      ctx.lineWidth = 16 * sizScale;
      ctx.arc(
        c.width / 2,
        c.height - 58 * sizScale,
        c.height / 1.8 - ctx.lineWidth,
        -Math.PI * 1.1,
        amount * Math.PI * 1.2 - Math.PI * 1.1
      );
      ctx.stroke();
      if (typeof progress !== "undefined") {
        ctx.fillStyle = prog;
        ctx.fillRect(
          c.width * 0.3,
          c.height - 16 * sizScale,
          c.width * 0.4 * progress,
          4 * sizScale
        );
      }
    },
    initUI() {
      this.drawMeter(this.$refs.dlMeter, 0, this.meterBk, this.dlColor, 0);
      this.drawMeter(this.$refs.ulMeter, 0, this.meterBk, this.ulColor, 0);
      this.drawMeter(this.$refs.pingMeter, 0, this.meterBk, this.pingColor, 0);
      this.drawMeter(this.$refs.jitMeter, 0, this.meterBk, this.jitColor, 0);
      this.dlText = "";
      this.ulText = "";
      this.pingText = "";
      this.jitText = "";
      this.ipAddress = "";
    },
  },
  mounted() {
    setTimeout(this.initUI, 100);
    setInterval(() => {
      if (this.w) this.w.postMessage("status");
    }, 200);
    const frame = () => {
      window.requestAnimationFrame(frame);
      this.updateUI();
    };
    frame();
  },
};
</script>

<style scoped>
html,
body {
  border: none;
  padding: 0;
  margin: 0;
  background: #ffffff;
  color: #202020;
}
body {
  text-align: center;
  font-family: "Roboto", sans-serif;
}
h1 {
  color: #404040;
}
#startStopBtn {
  display: inline-block;
  margin: 0 auto;
  color: #6060aa;
  background-color: rgba(0, 0, 0, 0);
  border: 0.15em solid #6060ff;
  border-radius: 0.3em;
  transition: all 0.3s;
  box-sizing: border-box;
  width: 8em;
  height: 3em;
  line-height: 2.7em;
  cursor: pointer;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.1), inset 0 0 0 rgba(0, 0, 0, 0.1);
}
#startStopBtn:hover {
  box-shadow: 0 0 2em rgba(0, 0, 0, 0.1), inset 0 0 1em rgba(0, 0, 0, 0.1);
}
#startStopBtn.running {
  background-color: #ff3030;
  border-color: #ff6060;
  color: #ffffff;
}
#startStopBtn:before {
  content: "Iniciar";
}
#startStopBtn.running:before {
  content: "Parar";
}
#test {
  margin-top: 2em;
  margin-bottom: 12em;
}
div.testArea {
  display: inline-block;
  width: 16em;
  height: 12.5em;
  position: relative;
  box-sizing: border-box;
}
div.testName {
  position: absolute;
  top: 0.1em;
  left: 0;
  width: 100%;
  font-size: 1.4em;
  z-index: 9;
}
div.meterText {
  position: absolute;
  bottom: 1.55em;
  left: 0;
  width: 100%;
  font-size: 2.5em;
  z-index: 9;
}
div.meterText:empty:before {
  content: "0.00";
}
div.unit {
  position: absolute;
  bottom: 2em;
  left: 0;
  width: 100%;
  z-index: 9;
}
div.testArea canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
div.testGroup {
  display: inline-block;
}
@media all and (max-width: 65em) {
  body {
    font-size: 1.5vw;
  }
}
@media all and (max-width: 40em) {
  body {
    font-size: 0.8em;
  }
  div.testGroup {
    display: block;
    margin: 0 auto;
  }
}
</style>
-->

<template>
  <div>
    <!-- <iframe
      id="iFrameSpeedId"
      ref="iFrameSpeedRef"
      src="/api-proxy/speedtestmundovoa"
      height="500px"
      style="width: 100%"
      scrolling="no"
      frameborder="no"
      loading="lazy"
      allowtransparency="true"
      allowfullscreen="true"
    ></iframe> -->
    <b-embed
      type="iframe"
      aspect="16by9"
      src="/api-proxy/speedtestmundovoa"
      allowfullscreen
    ></b-embed>
  </div>
</template>

<script>
export default {
  name: "SpeedTest",

  mounted() {
    // window.addEventListener("resize", this.ajustarAlturaIframe);
    // this.ajustarAlturaIframe();
  },

  methods: {
    ajustarAlturaIframe() {
      const iframe = this.$refs.iFrameSpeedRef;
      // Define a altura do iframe com base na altura do conteúdo
      iframe.style.height =
        iframe.contentWindow.document.body.scrollHeight + "px";
    },
  },
};
</script>


<!--

  <template>
    <div>
      <button @click="runSpeedTest">Testar Velocidade</button>
      <div v-if="speedTestRunning">Testando velocidade...</div>
      <div v-if="!speedTestRunning && speedTestResult">
        <p>Velocidade de download: {{ speedTestResult.download }} Mbps</p>
        <p>Velocidade de upload: {{ speedTestResult.upload }} Mbps</p>
      </div>
    </div>
  </template>
  
  <script>
  import SpeedTest from "speedtest-net";
  
  export default {
    data() {
      return {
        speedTestRunning: false,
        speedTestResult: null,
      };
    },
    methods: {
      async runSpeedTest() {
        this.speedTestRunning = true;
        const speedTest = SpeedTest({ maxTime: 5000 }); // Defina o tempo máximo para o teste (em milissegundos)
        const data = await speedTest.test();
        this.speedTestResult = {
          download: (data.speeds.download / 1e6).toFixed(2), // Converter de bytes para megabits
          upload: (data.speeds.upload / 1e6).toFixed(2),
        };
        this.speedTestRunning = false;
      },
    },
  };
  </script>
-->